import { API_ERROR_MESSAGE, OTP_ERROR_MESSAGE } from '../../utils/Constants'
import { API_CALL_TYPE, getAPIUrl } from '../API'
import { makeApiCall } from '../APIService'
interface sendOtpProps {
  setShowProgress: (value: boolean) => void
  setShowOTPFields: (value: boolean) => void
  setIsError: (value: boolean) => void
  setErrorMessage: (value: string) => void
  hfAgentID: string
}
export const sendOtp = (props: sendOtpProps): void => {
  const {
    hfAgentID,
    setErrorMessage,
    setShowProgress,
    setIsError,
    setShowOTPFields,
  } = props
  const API_URL: string = getAPIUrl() + '/Common/send-otp'
  const body: { productId: number } = {
    productId: 15,
  }
  setShowProgress(true)
  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response) => {
      setShowOTPFields(true)
      setShowProgress(false)
      setIsError(false)
    },
    (error) => {
      console.error(error)
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'), // string
    },
    null,
    false,
  )
}
